import {AppState} from '../app.state';
import {createSelector} from '@ngrx/store';
import {LayoutState} from '../../models/layout-state.model';

const selectLayout = (state: AppState) => state.layout;

export const selectTheme = () => createSelector(selectLayout, (layout: LayoutState) => layout.theme);

